export const partnerMapTranslations = {
  de: {
    publicAddress:
      'Ich bestätige: öffentliche Geschäftsadresse, keine private oder vertrauliche Adresse. Nominatim darf die Adressbestandteile zur Positionsbestimmung erhalten.',
    retryGeocoding: 'Position erneut prüfen',
    retryBlocked:
      'Prüfung derzeit nicht zulässig. Wartezeit, Privatadresse, manuelle Position oder zwischenzeitliche Änderung prüfen.',
    legacyAttribution: 'Historische Positionsdaten: Geoapify / © OpenStreetMap-Mitwirkende (ODbL).',
    reviewReasons: {
      PRIVACY:
        'Öffentliche Geschäftsadresse noch nicht bestätigt. Private oder vertrauliche Adressen bitte manuell positionieren.',
      IMPORT: 'Importadresse: keine automatische externe Sammelverarbeitung.',
      LEGACY: 'Altauftrag: beim Anbieterwechsel angehalten; bewusste Einzelprüfung erforderlich.',
      ADDRESS_CHANGED: 'Adresse geändert: manuelle Position erneut bestätigen.',
      PROVIDER_ERROR:
        'Adressdienst nicht verfügbar. Begrenzte Wiederholungen; danach manuell prüfen.',
      INTRODUCTION: 'Externe Adressprüfung im Einführungsmodus gesperrt.',
    },
    OTHER: 'Weiterer Standort',
    title: 'Partnerkarte',
    subtitle: 'Standorte finden und persönliche Besuche vorbereiten.',
    map: 'Karte',
    filters: 'Standorte und Kontaktfilter',
    roles: 'Rollen',
    customer: 'Kunden',
    prospect: 'Interessenten',
    supplier: 'Lieferanten',
    mixed: 'Mehrere Rollen',
    locations: 'Standorte',
    MAIN: 'Hauptadresse',
    SHIPPING: 'Lieferadressen',
    BILLING: 'Rechnungsadresse',
    ALL: 'Alle Standorte',
    city: 'Ort',
    postalCode: 'Postleitzahl',
    region: 'Region',
    owner: 'Zuständig',
    contactDays: 'Kein Kontakt seit Tagen',
    visitDays: 'Kein Besuch seit Tagen',
    neverContacted: 'Noch nie persönlich kontaktiert',
    addressReview: 'Adresse prüfen',
    clearRadius: 'Umkreis entfernen',
    contactHelp:
      'Persönliche Kontakte zählen nur bei tatsächlicher Interaktion. Besuche werden separat erfasst. „Seit Tagen“ schließt nie kontaktierte Partner ein. Filter gelten gemeinsam; Rollen und Tags jeweils alternativ.',
    radius: 'Umkreis',
    pickOrigin: 'Kartenpunkt wählen',
    myPosition: 'Meine Position verwenden',
    airDistance: 'Luftlinie',
    geoError:
      'Die aktuelle Position ist nicht verfügbar. Bitte einen Kartenpunkt oder Partner wählen.',
    setup:
      'Automatische Adresszuordnung ist deaktiviert oder unvollständig eingerichtet. Benötigt werden Nominatim-Anwendungskennung, gemeinsamer Koordinator und Worker. Gespeicherte Positionen bleiben nutzbar.',
    loadError: 'Standorte konnten nicht geladen werden. Bitte erneut versuchen.',
    legend: 'Legende',
    counts:
      '{{partners}} Partner · {{total}} Standorte · {{viewport}} im Kartenausschnitt · {{missing}} ohne verwendbare Position',
    updated: 'Stand: {{date}}',
    notRecorded: 'Nicht erfasst',
    lastContact: 'Letzter persönlicher Kontakt',
    lastVisit: 'Letzter Besuch',
    open: 'Partnerakte öffnen',
    visit: 'Besuch vorbereiten',
    nearby: 'Partner im Umkreis',
    navigate: 'Navigation öffnen',
    correct: 'Position korrigieren',
    latitude: 'Breitengrad',
    longitude: 'Längengrad',
    reason: 'Begründung',
    pickPosition: 'Position auf Karte wählen',
    saveError:
      'Position konnte nicht gespeichert werden. Eingaben prüfen und bei zwischenzeitlichen Änderungen den Standort neu laden.',
    results: 'Ergebnisliste',
    empty: 'Keine passenden Standorte. Filter anpassen.',
    geocodingBy: 'Adressauflösung:',
    tileError:
      'Die Karte konnte nicht vollständig geladen werden. Die Ergebnisliste bleibt nutzbar.',
    positionChanged: 'Die Adresse oder Position wurde inzwischen geändert. Bitte neu laden.',
    invalidRadius: 'Für einen Umkreis sind Ausgangspunkt und Radius erforderlich.',
    status: {
      PENDING: 'Wartet auf Adresszuordnung',
      PRECISE: 'Adressgenauer Treffer',
      APPROXIMATE: 'Ungefähre Position',
      AMBIGUOUS: 'Mehrdeutig – Adresse prüfen',
      NOT_FOUND: 'Kein Treffer – Adresse prüfen',
      ERROR: 'Adressdienst nicht verfügbar – erneuter Versuch geplant',
      MANUAL: 'Manuell bestätigt',
      REVIEW: 'Adresse oder Position prüfen',
    },
    pick: {
      radius: 'Ausgangspunkt auf der Karte anklicken.',
      manual: 'Korrigierte Position auf der Karte anklicken. Danach mit Begründung speichern.',
    },
    refresh: 'Aktualisieren',
    all: 'Alle',
  },
  en: {
    publicAddress:
      'I confirm: public business address, not a private or confidential address. Nominatim may receive the address components to determine its position.',
    retryGeocoding: 'Check position again',
    retryBlocked:
      'Check unavailable. Review the waiting period, private address, manual position or intervening changes.',
    legacyAttribution: 'Historical position data: Geoapify / © OpenStreetMap contributors (ODbL).',
    reviewReasons: {
      PRIVACY:
        'Public business address not confirmed. Position private or confidential addresses manually.',
      IMPORT: 'Imported address: no automatic external bulk processing.',
      LEGACY: 'Legacy job held during provider change; deliberate individual review required.',
      ADDRESS_CHANGED: 'Address changed: confirm the manual position again.',
      PROVIDER_ERROR: 'Address service unavailable. Retries are limited; then review manually.',
      INTRODUCTION: 'External geocoding blocked in introduction mode.',
    },
    OTHER: 'Other location',
    title: 'Partner map',
    subtitle: 'Find locations and prepare personal visits.',
    map: 'Map',
    filters: 'Locations and contact filters',
    roles: 'Roles',
    customer: 'Customers',
    prospect: 'Prospects',
    supplier: 'Suppliers',
    mixed: 'Multiple roles',
    locations: 'Locations',
    MAIN: 'Main address',
    SHIPPING: 'Delivery addresses',
    BILLING: 'Billing address',
    ALL: 'All locations',
    city: 'City',
    postalCode: 'Postal code',
    region: 'Region',
    owner: 'Responsible person',
    contactDays: 'No contact for days',
    visitDays: 'No visit for days',
    neverContacted: 'Never personally contacted',
    addressReview: 'Review address',
    clearRadius: 'Clear radius',
    contactHelp:
      'Personal contact requires actual interaction. Visits are recorded separately. Days without contact include partners never contacted. Filters apply together; roles and tags match any selected value.',
    radius: 'Radius',
    pickOrigin: 'Choose map point',
    myPosition: 'Use my location',
    airDistance: 'Straight-line distance',
    geoError: 'Your location is unavailable. Choose a map point or partner.',
    setup:
      'Automatic geocoding is disabled or incomplete. Configure the Nominatim application identity, shared coordinator and worker. Saved positions remain usable.',
    loadError: 'Locations could not be loaded. Please retry.',
    legend: 'Legend',
    counts:
      '{{partners}} partners · {{total}} locations · {{viewport}} in map area · {{missing}} without usable position',
    updated: 'Updated: {{date}}',
    notRecorded: 'Not recorded',
    lastContact: 'Last personal contact',
    lastVisit: 'Last visit',
    open: 'Open partner record',
    visit: 'Prepare visit',
    nearby: 'Nearby partners',
    navigate: 'Open navigation',
    correct: 'Correct position',
    latitude: 'Latitude',
    longitude: 'Longitude',
    reason: 'Reason',
    pickPosition: 'Choose position on map',
    saveError:
      'Position could not be saved. Check the inputs and reload the location if it changed meanwhile.',
    results: 'Results',
    empty: 'No matching locations. Adjust the filters.',
    geocodingBy: 'Geocoding:',
    tileError: 'The map could not be fully loaded. The results list remains usable.',
    positionChanged: 'The address or position changed meanwhile. Please reload.',
    invalidRadius: 'A radius requires both an origin and distance.',
    status: {
      PENDING: 'Awaiting geocoding',
      PRECISE: 'Address-level match',
      APPROXIMATE: 'Approximate position',
      AMBIGUOUS: 'Ambiguous – review address',
      NOT_FOUND: 'No match – review address',
      ERROR: 'Geocoding unavailable – retry scheduled',
      MANUAL: 'Manually confirmed',
      REVIEW: 'Review address or position',
    },
    pick: {
      radius: 'Click the origin on the map.',
      manual: 'Click the corrected position, then save with a reason.',
    },
    refresh: 'Refresh',
    all: 'All',
  },
  fr: {
    publicAddress:
      'Je confirme : adresse professionnelle publique, ni privée ni confidentielle. Nominatim peut recevoir les éléments de l’adresse pour la localiser.',
    retryGeocoding: 'Revérifier la position',
    retryBlocked:
      'Vérification indisponible. Vérifiez le délai, l’adresse privée, la position manuelle ou les modifications intermédiaires.',
    legacyAttribution: 'Positions historiques : Geoapify / © contributeurs OpenStreetMap (ODbL).',
    reviewReasons: {
      PRIVACY:
        'Adresse professionnelle publique non confirmée. Positionnez manuellement les adresses privées ou confidentielles.',
      IMPORT: 'Adresse importée : aucun traitement externe groupé automatique.',
      LEGACY:
        'Ancienne tâche suspendue lors du changement de fournisseur ; vérification individuelle explicite requise.',
      ADDRESS_CHANGED: 'Adresse modifiée : reconfirmez la position manuelle.',
      PROVIDER_ERROR: 'Service indisponible. Tentatives limitées, puis vérification manuelle.',
      INTRODUCTION: 'Géocodage externe bloqué en mode introduction.',
    },
    OTHER: 'Autre site',
    title: 'Carte des partenaires',
    subtitle: 'Repérer les sites et préparer les visites.',
    map: 'Carte',
    filters: 'Sites et filtres de contact',
    roles: 'Rôles',
    customer: 'Clients',
    prospect: 'Prospects',
    supplier: 'Fournisseurs',
    mixed: 'Plusieurs rôles',
    locations: 'Sites',
    MAIN: 'Adresse principale',
    SHIPPING: 'Adresses de livraison',
    BILLING: 'Adresse de facturation',
    ALL: 'Tous les sites',
    city: 'Ville',
    postalCode: 'Code postal',
    region: 'Région',
    owner: 'Responsable',
    contactDays: 'Sans contact depuis (jours)',
    visitDays: 'Sans visite depuis (jours)',
    neverContacted: 'Jamais contacté personnellement',
    addressReview: 'Vérifier l’adresse',
    clearRadius: 'Supprimer le rayon',
    contactHelp:
      'Un contact personnel nécessite une interaction réelle. Les visites sont enregistrées séparément. Le délai inclut les partenaires jamais contactés. Les filtres se combinent ; les rôles et étiquettes sont alternatifs.',
    radius: 'Rayon',
    pickOrigin: 'Choisir un point',
    myPosition: 'Utiliser ma position',
    airDistance: 'À vol d’oiseau',
    geoError: 'Position indisponible. Choisissez un point ou un partenaire.',
    setup:
      'Géocodage désactivé ou incomplet. Configurez l’identité Nominatim, le coordinateur commun et le worker. Les positions enregistrées restent utilisables.',
    loadError: 'Impossible de charger les sites. Réessayez.',
    legend: 'Légende',
    counts:
      '{{partners}} partenaires · {{total}} sites · {{viewport}} sur la carte · {{missing}} sans position exploitable',
    updated: 'Actualisé : {{date}}',
    notRecorded: 'Non enregistré',
    lastContact: 'Dernier contact personnel',
    lastVisit: 'Dernière visite',
    open: 'Ouvrir la fiche',
    visit: 'Préparer une visite',
    nearby: 'Partenaires à proximité',
    navigate: 'Ouvrir la navigation',
    correct: 'Corriger la position',
    latitude: 'Latitude',
    longitude: 'Longitude',
    reason: 'Motif',
    pickPosition: 'Choisir la position sur la carte',
    saveError:
      'Impossible d’enregistrer la position. Vérifiez les valeurs et rechargez le site s’il a été modifié.',
    results: 'Résultats',
    empty: 'Aucun site correspondant. Adaptez les filtres.',
    geocodingBy: 'Géocodage :',
    tileError: 'La carte n’a pas pu être entièrement chargée. La liste reste utilisable.',
    positionChanged: 'L’adresse ou la position a changé. Rechargez les données.',
    invalidRadius: 'Un rayon nécessite un point de départ et une distance.',
    status: {
      PENDING: 'Géocodage en attente',
      PRECISE: 'Correspondance précise',
      APPROXIMATE: 'Position approximative',
      AMBIGUOUS: 'Ambigu – vérifier l’adresse',
      NOT_FOUND: 'Aucun résultat – vérifier l’adresse',
      ERROR: 'Service indisponible – nouvelle tentative prévue',
      MANUAL: 'Confirmée manuellement',
      REVIEW: 'Vérifier l’adresse ou la position',
    },
    pick: {
      radius: 'Cliquez sur le point de départ.',
      manual: 'Cliquez sur la position corrigée, puis enregistrez avec un motif.',
    },
    refresh: 'Actualiser',
    all: 'Tous',
  },
  es: {
    publicAddress:
      'Confirmo: dirección comercial pública, no privada ni confidencial. Nominatim puede recibir sus componentes para determinar la posición.',
    retryGeocoding: 'Comprobar posición de nuevo',
    retryBlocked:
      'Comprobación no disponible. Revise la espera, dirección privada, posición manual o cambios simultáneos.',
    legacyAttribution: 'Posiciones históricas: Geoapify / © colaboradores de OpenStreetMap (ODbL).',
    reviewReasons: {
      PRIVACY:
        'Dirección comercial pública sin confirmar. Sitúe manualmente las direcciones privadas o confidenciales.',
      IMPORT: 'Dirección importada: sin procesamiento externo masivo automático.',
      LEGACY:
        'Tarea antigua suspendida al cambiar de proveedor; requiere revisión individual explícita.',
      ADDRESS_CHANGED: 'Dirección modificada: confirme de nuevo la posición manual.',
      PROVIDER_ERROR: 'Servicio no disponible. Reintentos limitados; después, revisión manual.',
      INTRODUCTION: 'Geocodificación externa bloqueada en modo de introducción.',
    },
    OTHER: 'Otra sede',
    title: 'Mapa de socios',
    subtitle: 'Localizar sedes y preparar visitas personales.',
    map: 'Mapa',
    filters: 'Sedes y filtros de contacto',
    roles: 'Funciones',
    customer: 'Clientes',
    prospect: 'Clientes potenciales',
    supplier: 'Proveedores',
    mixed: 'Varias funciones',
    locations: 'Sedes',
    MAIN: 'Dirección principal',
    SHIPPING: 'Direcciones de entrega',
    BILLING: 'Dirección de facturación',
    ALL: 'Todas las sedes',
    city: 'Ciudad',
    postalCode: 'Código postal',
    region: 'Región',
    owner: 'Responsable',
    contactDays: 'Sin contacto desde (días)',
    visitDays: 'Sin visita desde (días)',
    neverContacted: 'Nunca contactado personalmente',
    addressReview: 'Revisar dirección',
    clearRadius: 'Quitar radio',
    contactHelp:
      'El contacto personal requiere una interacción real. Las visitas se registran por separado. El plazo incluye socios nunca contactados. Los filtros se combinan; funciones y etiquetas son alternativas.',
    radius: 'Radio',
    pickOrigin: 'Elegir punto del mapa',
    myPosition: 'Usar mi ubicación',
    airDistance: 'Distancia en línea recta',
    geoError: 'Ubicación no disponible. Elija un punto o un socio.',
    setup:
      'Geocodificación desactivada o incompleta. Configure la identidad Nominatim, el coordinador común y el worker. Las posiciones guardadas siguen disponibles.',
    loadError: 'No se pudieron cargar las sedes. Inténtelo de nuevo.',
    legend: 'Leyenda',
    counts:
      '{{partners}} socios · {{total}} sedes · {{viewport}} en el mapa · {{missing}} sin posición utilizable',
    updated: 'Actualizado: {{date}}',
    notRecorded: 'No registrado',
    lastContact: 'Último contacto personal',
    lastVisit: 'Última visita',
    open: 'Abrir ficha',
    visit: 'Preparar visita',
    nearby: 'Socios cercanos',
    navigate: 'Abrir navegación',
    correct: 'Corregir posición',
    latitude: 'Latitud',
    longitude: 'Longitud',
    reason: 'Motivo',
    pickPosition: 'Elegir posición en el mapa',
    saveError:
      'No se pudo guardar la posición. Revise los datos y recargue la sede si se ha modificado.',
    results: 'Resultados',
    empty: 'No hay sedes coincidentes. Ajuste los filtros.',
    geocodingBy: 'Geocodificación:',
    tileError: 'El mapa no se ha podido cargar completamente. La lista sigue funcionando.',
    positionChanged: 'La dirección o posición ha cambiado. Recargue los datos.',
    invalidRadius: 'El radio requiere un origen y una distancia.',
    status: {
      PENDING: 'Geocodificación pendiente',
      PRECISE: 'Coincidencia precisa',
      APPROXIMATE: 'Posición aproximada',
      AMBIGUOUS: 'Ambigua – revisar dirección',
      NOT_FOUND: 'Sin coincidencia – revisar dirección',
      ERROR: 'Servicio no disponible – reintento previsto',
      MANUAL: 'Confirmada manualmente',
      REVIEW: 'Revisar dirección o posición',
    },
    pick: {
      radius: 'Pulse el punto de origen.',
      manual: 'Pulse la posición corregida y guarde con un motivo.',
    },
    refresh: 'Actualizar',
    all: 'Todos',
  },
  tr: {
    publicAddress:
      'Onaylıyorum: herkese açık iş adresi; özel veya gizli adres değildir. Nominatim konumu belirlemek için adres bileşenlerini alabilir.',
    retryGeocoding: 'Konumu yeniden kontrol et',
    retryBlocked:
      'Kontrol kullanılamıyor. Bekleme süresini, özel adresi, manuel konumu veya eşzamanlı değişiklikleri kontrol edin.',
    legacyAttribution: 'Geçmiş konum verileri: Geoapify / © OpenStreetMap katkıcıları (ODbL).',
    reviewReasons: {
      PRIVACY: 'Herkese açık iş adresi onaylanmadı. Özel veya gizli adresleri elle konumlandırın.',
      IMPORT: 'İçe aktarılan adres: otomatik harici toplu işlem yapılmaz.',
      LEGACY: 'Eski görev sağlayıcı değişiminde durduruldu; açıkça tekil kontrol gerekir.',
      ADDRESS_CHANGED: 'Adres değişti: manuel konumu yeniden onaylayın.',
      PROVIDER_ERROR:
        'Adres hizmeti kullanılamıyor. Denemeler sınırlıdır; ardından elle kontrol edin.',
      INTRODUCTION: 'Tanıtım modunda harici adres çözümleme engellendi.',
    },
    OTHER: 'Diğer konum',
    title: 'İş ortağı haritası',
    subtitle: 'Konumları bulun ve kişisel ziyaretleri hazırlayın.',
    map: 'Harita',
    filters: 'Konum ve iletişim filtreleri',
    roles: 'Roller',
    customer: 'Müşteriler',
    prospect: 'Potansiyel müşteriler',
    supplier: 'Tedarikçiler',
    mixed: 'Birden fazla rol',
    locations: 'Konumlar',
    MAIN: 'Ana adres',
    SHIPPING: 'Teslimat adresleri',
    BILLING: 'Fatura adresi',
    ALL: 'Tüm konumlar',
    city: 'Şehir',
    postalCode: 'Posta kodu',
    region: 'Bölge',
    owner: 'Sorumlu',
    contactDays: 'Gündür iletişim yok',
    visitDays: 'Gündür ziyaret yok',
    neverContacted: 'Hiç kişisel iletişim kurulmadı',
    addressReview: 'Adresi kontrol et',
    clearRadius: 'Yarıçapı kaldır',
    contactHelp:
      'Kişisel iletişim gerçek etkileşim gerektirir. Ziyaretler ayrı kaydedilir. Gün filtresi hiç iletişim kurulmamış ortakları da içerir. Filtreler birlikte uygulanır; rol ve etiketler alternatif olarak eşleşir.',
    radius: 'Yarıçap',
    pickOrigin: 'Haritada nokta seç',
    myPosition: 'Konumumu kullan',
    airDistance: 'Kuş uçuşu',
    geoError: 'Konumunuz kullanılamıyor. Haritada nokta veya iş ortağı seçin.',
    setup:
      'Otomatik adres çözümleme kapalı veya eksik. Nominatim uygulama kimliğini, ortak koordinatörü ve worker hizmetini yapılandırın. Kayıtlı konumlar kullanılabilir.',
    loadError: 'Konumlar yüklenemedi. Yeniden deneyin.',
    legend: 'Gösterge',
    counts:
      '{{partners}} ortak · {{total}} konum · haritada {{viewport}} · kullanılabilir konumu olmayan {{missing}}',
    updated: 'Güncelleme: {{date}}',
    notRecorded: 'Kaydedilmedi',
    lastContact: 'Son kişisel iletişim',
    lastVisit: 'Son ziyaret',
    open: 'Ortak kaydını aç',
    visit: 'Ziyaret hazırla',
    nearby: 'Yakındaki ortaklar',
    navigate: 'Navigasyonu aç',
    correct: 'Konumu düzelt',
    latitude: 'Enlem',
    longitude: 'Boylam',
    reason: 'Gerekçe',
    pickPosition: 'Haritada konum seç',
    saveError:
      'Konum kaydedilemedi. Girdileri kontrol edin; bu sırada değiştiyse konumu yeniden yükleyin.',
    results: 'Sonuçlar',
    empty: 'Eşleşen konum yok. Filtreleri düzenleyin.',
    geocodingBy: 'Adres çözümleme:',
    tileError: 'Harita tamamen yüklenemedi. Sonuç listesi kullanılabilir.',
    positionChanged: 'Adres veya konum değişti. Yeniden yükleyin.',
    invalidRadius: 'Yarıçap için başlangıç noktası ve mesafe gereklidir.',
    status: {
      PENDING: 'Adres çözümleme bekleniyor',
      PRECISE: 'Adres düzeyinde eşleşme',
      APPROXIMATE: 'Yaklaşık konum',
      AMBIGUOUS: 'Belirsiz – adresi kontrol edin',
      NOT_FOUND: 'Eşleşme yok – adresi kontrol edin',
      ERROR: 'Adres hizmeti kullanılamıyor – tekrar denenecek',
      MANUAL: 'Elle onaylandı',
      REVIEW: 'Adresi veya konumu kontrol edin',
    },
    pick: {
      radius: 'Başlangıç noktasına tıklayın.',
      manual: 'Düzeltilmiş konuma tıklayıp gerekçeyle kaydedin.',
    },
    refresh: 'Yenile',
    all: 'Tümü',
  },
} as const;
